import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";
import { Input } from "@/shared/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select";
import { WORKSPACE_SEARCH_CHANNELS, type WorkspaceSearchChannel } from "../types/workspaceSearch";

interface Props {
    orgId: string;
    onOrgIdChange: (v: string) => void;
    channel: WorkspaceSearchChannel;
    onChannelChange: (v: WorkspaceSearchChannel) => void;
    dwAccountId: string;
    onDwAccountIdChange: (v: string) => void;
    onSubmit: () => void;
    disabled?: boolean;
}

export function WorkspaceSearchFormCard(props: Props) {
    return (
        <Card className="p-4">
            <div className="flex flex-wrap items-end gap-3">
                <div className="space-y-1">
                    <div className="text-sm font-medium">org_id</div>
                    <Input value={props.orgId} onChange={(e) => props.onOrgIdChange(e.target.value)} className="w-[220px]" />
                </div>

                <div className="space-y-1">
                    <div className="text-sm font-medium">channel</div>
                    <Select value={props.channel} onValueChange={(v) => props.onChannelChange(v as WorkspaceSearchChannel)}>
                        <SelectTrigger className="w-[220px]">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {WORKSPACE_SEARCH_CHANNELS.map((c) => (
                                <SelectItem key={c} value={c}>
                                    {c}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>

                <div className="space-y-1">
                    <div className="text-sm font-medium">dw_account_id</div>
                    <Input
                        value={props.dwAccountId}
                        onChange={(e) => props.onDwAccountIdChange(e.target.value)}
                        className="w-[220px]"
                    />
                </div>

                <Button onClick={props.onSubmit} disabled={props.disabled}>
                    조회
                </Button>
            </div>
        </Card>
    );
}